import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
import React from 'react';
const UpdateFieldsModalSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex animate-pulse flex-col justify-between gap-7"><Skeleton className="rounded-sm py-2.5 text-transparent">.</Skeleton><Skeleton className="rounded-sm py-2.5 text-transparent">.</Skeleton><Skeleton className="rounded-sm py-2.5 text-transparent">.</Skeleton><Skeleton className="rounded-sm py-2.5 text-transparent">.</Skeleton><Skeleton className="rounded-sm py-2.5 text-transparent">.</Skeleton><Skeleton className="rounded-sm py-2.5 text-transparent">.</Skeleton><Skeleton className="rounded-sm py-2.5 text-transparent">.</Skeleton></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default UpdateFieldsModalSkeleton;